var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wallet wallet-history-page coin1-page" }, [
    _c("div", { staticClass: "coin1-summary" }, [
      _c("div", { staticClass: "summary-item summary-total" }, [
        _c("span", { staticClass: "summary-label" }, [_vm._v("金豆总余额")]),
        _c("strong", [_vm._v(_vm._s(_vm.formatAmount(_vm.balance.total)))]),
      ]),
      _c("div", { staticClass: "summary-item" }, [
        _c("span", { staticClass: "summary-label" }, [_vm._v("可用余额")]),
        _c("strong", [_vm._v(_vm._s(_vm.formatAmount(_vm.balance.available)))]),
      ]),
      _c("div", { staticClass: "summary-item summary-frozen" }, [
        _c("span", { staticClass: "summary-label" }, [_vm._v("冻结中")]),
        _c("strong", [_vm._v(_vm._s(_vm.formatAmount(_vm.balance.frozen)))]),
      ]),
    ]),
    _vm.$canShowFeature("coin1_exchange")
      ? _c("div", { staticClass: "coin1-exchange" }, [
          _c("div", { staticClass: "exchange-heading" }, [
            _c("span", { staticClass: "exchange-title" }, [
              _vm._v("金豆兑换余额"),
            ]),
            _c("span", { staticClass: "exchange-rate" }, [
              _vm._v(
                "兑换比例：" +
                  _vm._s(_vm.formatAmount(_vm.exchangeRate)) +
                  " 金豆 = 1 余额"
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "exchange-form" },
            [
              _c(
                "Input",
                {
                  staticClass: "exchange-input",
                  attrs: {
                    type: "number",
                    min: "0.01",
                    step: "0.01",
                    placeholder: "请输入想兑换的余额数量",
                  },
                  model: {
                    value: _vm.exchangeCashInput,
                    callback: function ($$v) {
                      _vm.exchangeCashInput = $$v
                    },
                    expression: "exchangeCashInput",
                  },
                },
                [
                  _c("span", { attrs: { slot: "prepend" }, slot: "prepend" }, [
                    _vm._v("余额"),
                  ]),
                ]
              ),
              _c("span", { staticClass: "exchange-equals" }, [_vm._v("=")]),
              _c("span", { staticClass: "exchange-preview" }, [
                _vm._v("消耗 " + _vm._s(_vm.exchangeCoin1Amount) + " 金豆"),
              ]),
              _c(
                "Button",
                {
                  attrs: { type: "primary", loading: _vm.exchangeLoading },
                  on: { click: _vm.exchangeCash },
                },
                [_vm._v("立即兑换")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "exchange-hint" },
            [
              _vm._v(
                " 最低起兑 " +
                  _vm._s(_vm.formatAmount(_vm.exchangeMinAmount)) +
                  " 金豆，且消耗金豆必须是整数； "
              ),
              _vm.exchangeDailyMaxCashAmount > 0
                ? [
                    _vm._v(
                      "今日剩余可兑换 " +
                        _vm._s(
                          _vm.formatAmount(_vm.exchangeDailyRemainingCashAmount)
                        ) +
                        " 余额；"
                    ),
                  ]
                : [_vm._v("每日兑换不限额；")],
              _vm._v(
                " 可用 " +
                  _vm._s(_vm.formatAmount(_vm.balance.available)) +
                  " 金豆 "
              ),
            ],
            2
          ),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "coin1-toolbar" },
      [
        _c("span", { staticClass: "toolbar-title" }, [_vm._v("金豆流水")]),
        _c(
          "Select",
          {
            staticClass: "coin1-filter cs-custom-select",
            attrs: { size: "small", "dropdown-class-name": "cs-dark-dropdown" },
            on: { "on-change": _vm.resetAndLoad },
            model: {
              value: _vm.changeType,
              callback: function ($$v) {
                _vm.changeType = $$v
              },
              expression: "changeType",
            },
          },
          [
            _c("Option", { attrs: { value: "all" } }, [_vm._v("全部类型")]),
            _c("Option", { attrs: { value: "AddAvailable" } }, [
              _vm._v("增加"),
            ]),
            _c("Option", { attrs: { value: "DeductAvailable" } }, [
              _vm._v("扣除"),
            ]),
            _c("Option", { attrs: { value: "Freeze" } }, [_vm._v("冻结")]),
            _c("Option", { attrs: { value: "Unfreeze" } }, [_vm._v("解冻")]),
            _c("Option", { attrs: { value: "DeductFrozen" } }, [
              _vm._v("扣除冻结"),
            ]),
          ],
          1
        ),
        _c("DatePicker", {
          staticClass: "coin1-date-filter",
          attrs: {
            type: "daterange",
            size: "small",
            placement: "bottom-end",
            placeholder: "选择时间范围",
          },
          on: { "on-change": _vm.resetAndLoad },
          model: {
            value: _vm.dateRange,
            callback: function ($$v) {
              _vm.dateRange = $$v
            },
            expression: "dateRange",
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "wallet_detail_box" }, [
      _c("table", { staticClass: "list coin1-list" }, [
        _vm._m(0),
        _c(
          "tbody",
          _vm._l(_vm.items, function (item) {
            return _c("tr", { key: item.id }, [
              _c("td", [
                _c("span", { class: _vm.amountClass(item) }, [
                  _vm._v(_vm._s(_vm.signedAmount(item.amount))),
                ]),
              ]),
              _c("td", [
                _c(
                  "span",
                  {
                    staticClass: "type-badge",
                    class: _vm.typeClass(item.type),
                  },
                  [_vm._v(_vm._s(item.typeName))]
                ),
              ]),
              _c("td", [
                _vm._v(_vm._s(_vm.formatAmount(item.availableBalance))),
              ]),
              _c("td", [_vm._v(_vm._s(_vm.formatAmount(item.frozenBalance)))]),
              _c("td", { staticClass: "reason" }, [
                _vm._v(_vm._s(item.reason || "-")),
              ]),
              _c("td", { staticClass: "time" }, [
                _vm._v(_vm._s(_vm.formatTime(item.createTime))),
              ]),
            ])
          }),
          0
        ),
      ]),
      !_vm.loading && !_vm.items.length
        ? _c("div", { staticClass: "none-item" }, [
            _c("img", {
              attrs: { src: require("@/assets/images/none-item.svg"), alt: "" },
            }),
            _c("div", [_vm._v("暂无金豆流水")]),
          ])
        : _vm._e(),
      _vm.loading
        ? _c("div", { staticClass: "coin1-loading" }, [_vm._v("加载中...")])
        : _vm._e(),
    ]),
    _vm.hasMore
      ? _c(
          "div",
          { staticClass: "coin1-more" },
          [
            _c(
              "Button",
              {
                attrs: { type: "primary", loading: _vm.loading },
                on: { click: _vm.loadMore },
              },
              [_vm._v("加载更多")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("变动")]),
        _c("th", [_vm._v("类型")]),
        _c("th", [_vm._v("变动后可用")]),
        _c("th", [_vm._v("变动后冻结")]),
        _c("th", [_vm._v("说明")]),
        _c("th", [_vm._v("时间")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }